import { ArrowLeft02Icon, Logout03Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { Button } from "@unfiddle/ui/components/button"
import {
   Menu,
   MenuGroup,
   MenuGroupLabel,
   MenuItem,
   MenuPopup,
   MenuSeparator,
   MenuTrigger,
} from "@unfiddle/ui/components/menu"
import { cn } from "@unfiddle/ui/utils"
import { useAuth } from "@/auth/hooks"
import { BackButton } from "@/ui/components/back-button"
import { UserAvatar } from "@/user/components/user-avatar"
import { WorkspaceLogo } from "@/workspace/components/workspace-logo"
import { WorkspaceMenuPopup } from "@/workspace/components/workspace-menu"

export function Header({
   className,
   children,
   ...props
}: React.ComponentProps<"header">) {
   return (
      <header
         className={cn(
            "z-5 grid h-(--header-height) shrink-0 grid-cols-[minmax(0,36px)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,36px)] items-center border-neutral border-b bg-background-main px-2 max-md:shadow-[0_1px_1px_0_rgb(0_0_0/0.05)] md:hidden md:pr-1.5 md:pl-3",
            className,
         )}
         {...props}
      >
         {children}
      </header>
   )
}

export function HeaderBackButton({
   className,
   ...props
}: React.ComponentProps<typeof Button>) {
   return (
      <BackButton
         variant={"ghost"}
         kind={"icon"}
         className={cn("md:hidden", className)}
         aria-label="Go back"
         {...props}
      >
         <HugeiconsIcon
            icon={ArrowLeft02Icon}
            className="size-5.5"
         />
      </BackButton>
   )
}

export function HeaderWorkspaceMenu() {
   const auth = useAuth()

   return (
      <Menu>
         <MenuTrigger
            render={
               <Button
                  variant={"ghost"}
                  kind={"icon"}
                  className="rounded-full! md:pl-0.75 md:text-base"
                  aria-label="Workspace options"
               >
                  <WorkspaceLogo
                     size={28}
                     className="rounded-full"
                     workspace={auth.workspace}
                  />
               </Button>
            }
         />
         <WorkspaceMenuPopup />
      </Menu>
   )
}

export function HeaderUserMenu() {
   const auth = useAuth()

   return (
      <Menu>
         <MenuTrigger
            render={
               <Button
                  variant={"ghost"}
                  kind={"icon"}
                  className="col-start-5 ml-auto rounded-full!"
               >
                  <UserAvatar
                     size={28}
                     user={auth.user}
                  />
               </Button>
            }
         />
         <MenuPopup
            align="end"
            className={"w-full max-w-60"}
         >
            <MenuGroup>
               <MenuGroupLabel className={"mb-1.5 line-clamp-1 normal-case"}>
                  {auth.user.email}
               </MenuGroupLabel>
               <MenuSeparator />
               <MenuItem
                  destructive
                  onClick={() => auth.signout.mutate()}
               >
                  <HugeiconsIcon icon={Logout03Icon} />
                  Вийти з аккаунту
               </MenuItem>
            </MenuGroup>
         </MenuPopup>
      </Menu>
   )
}

export function HeaderTitle({
   className,
   ...props
}: React.ComponentProps<"p">) {
   return (
      <p
         className={cn(
            "col-start-2 col-end-5 whitespace-nowrap text-center font-medium text-lg md:text-left md:text-base",
            className,
         )}
         {...props}
      />
   )
}

export function HeaderSeparator() {
   return (
      <svg
         viewBox="0 0 15 15"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className="-mt-0.5 inline-block size-5 md:size-4"
      >
         <path
            d="M12 3.5L4 11.5"
            stroke="currentColor"
            strokeWidth="1.33"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}
